import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const Sidebar = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { path: '/management/dashboard', icon: '📊', label: 'Dashboard' },
    { path: '/management/categories', icon: '📁', label: 'Categories' },
    { path: '/management/brands', label: 'Brands', icon: '🏷️' },
    { path: '/management/products', icon: '📦', label: 'Products' },
    { path: '/management/payment-settings', label: 'Payment Settings', icon: '💳' },
    { path: '/management/orders', icon: '🛒', label: 'Orders' },
  ];

  const handleNavigate = (path) => {
    navigate(path);
    // Close sidebar on mobile after navigation
    if (window.innerWidth <= 768 && onClose) {
      onClose();
    }
  };

  return (
    <>
      {/* Overlay for mobile - only show when sidebar is open */}
      {isOpen && (
        <div 
          className="sidebar-overlay" 
          onClick={onClose}
        />
      )}

      {/* Sidebar - add 'open' class when isOpen is true */}
      <div className={`admin-sidebar ${isOpen ? 'open' : ''}`}>
        <div className="sidebar-header">
          <div className="sidebar-logo">
            <span>🛍️</span>
            <span>Admin Panel</span>
          </div>
          
          {/* Close button - only visible on mobile */}
          <button 
            className="sidebar-close-btn"
            onClick={onClose}
            aria-label="Close menu"
          >
            ✕
          </button>
        </div>
        
        <nav className="sidebar-nav">
          {menuItems.map((item) => (
            <div
              key={item.path}
              className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
              onClick={() => handleNavigate(item.path)}
            >
              <span className="nav-icon">{item.icon}</span>
              <span>{item.label}</span>
            </div>
          ))}
        </nav>
      </div>
    </>
  );
};

export default Sidebar;